import { ApolloCache } from "@apollo/client";

/**
 * Évince des champs racine du cache Apollo après une mutation.
 *
 * `refetchQueries` ne rafraîchit que les queries actuellement montées : une liste
 * démontée au moment de la mutation resservirait son cache périmé au retour.
 * L'éviction force son rechargement au prochain montage.
 */
export const evictFields = (cache: ApolloCache<any>, fieldNames: string[]) => {
  fieldNames.forEach((fieldName) => {
    cache.evict({ id: "ROOT_QUERY", fieldName });
  });
  cache.gc();
};
